import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import * as filters from '@/filters/I18nFilters'
import { Locale } from 'vant'

Vue.use(VueI18n)

function getCookie(cookieName: string) {
	var allcookies = document.cookie
	var value = ''
	var cookie_pos = allcookies.indexOf(cookieName)
	if (cookie_pos != -1) {
		cookie_pos = cookie_pos + cookieName.length + 1
		var cookie_end = allcookies.indexOf(';', cookie_pos)

		if (cookie_end == -1) {
			cookie_end = allcookies.length
		}
		value = unescape(allcookies.substring(cookie_pos, cookie_end))
	}
	return value
}

var currentLocale = getCookie('Language') || navigator.language.toLowerCase()

const i18nIviewMap: { [key: string]: string } = {
	'en-us': 'en-US',
	'zh-tw': 'zh-TW',
	'zh-cn': 'zh-CN',
}
const allowLanguage: { [id: string]: string } = {
	'en-us': 'en-us',
	'zh-tw': 'zh-tw',
	'zh-cn': 'zh-cn',
}

function loadLocaleMessages(): LocaleMessages {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const iviewLocales = require.context('view-design/dist/locale', true, /[A-Za-z0-9-_,\s]+\.js$/i)
	const vantLocales = require.context('vant/lib/locale/lang/', true, /[A-Za-z0-9-_,\s]+\.js$/i)
	const messages: LocaleMessages = {}
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = Object.assign(
				locales(key),
				iviewLocales('./' + i18nIviewMap[locale] + '.js')['default'],
				vantLocales(`./${i18nIviewMap[locale]}.js`)['default'],
			)
		}
	})

	return messages
}

//如果為符合的語系才能設定，否則預設回中文
if (allowLanguage[currentLocale]) {
	currentLocale = currentLocale.toLowerCase() || process.env.VUE_APP_I18N_LOCALE || 'zh-tw'
} else {
	currentLocale = 'zh-tw'
}

//vant套件使用i18n
Locale.use(currentLocale, loadLocaleMessages()[currentLocale])

const fallbackLocale = currentLocale.toLowerCase() || process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'zh-tw'

Vue.locale = () => {}
let i18n = new VueI18n({
	locale: currentLocale,
	fallbackLocale: fallbackLocale,
	messages: loadLocaleMessages(),
})

//註冊所有i18n專用filter
Object.keys(filters).forEach(filter => {
	Vue.filter(filter, (filters as any)[filter](i18n))
})

export default i18n
